import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { IconButton, Avatar, Menu, MenuItem, ListItemIcon, ListItemText, Divider } from "@mui/material";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import PersonIcon from "@mui/icons-material/Person";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import { useAuth } from "../context/AuthContext";
import { ThemeContext } from "../context/ThemeContext";
import ENV from "../config/env";
import { useNavigate } from "react-router-dom";

const UserAvatar = () => {
  const [profilePicture, setProfilePicture] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const { logout } = useAuth();
  const { darkMode, toggleDarkMode } = useContext(ThemeContext);

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) return;

        const response = await axios.get(ENV.API_BASE_URL + "/api/auth/profile", {
          headers: { Authorization: `Bearer ${token}` },
        });

        setProfilePicture(response.data.profilePicture);
      } catch (error) {
        console.error("Error obteniendo el perfil del usuario", error);
      }
    };

    fetchUserProfile();
  }, []);

  const handleUserMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleUserMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleUserMenuClose();
    logout();
    //window.location.href = "/login";
  };

  const navigate = useNavigate();

  return (
    <>
      <IconButton onClick={handleUserMenuOpen}>
        <Avatar
          alt="Usuario"
          src={
            profilePicture
              ? `${ENV.API_BASE_URL}${profilePicture}`   // cuando SÍ hay foto
              : "/uploads/default-avatar.png"           // cuando NO hay foto
          }
        />
      </IconButton>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleUserMenuClose}>
        <MenuItem onClick={() => navigate("/mi-cuenta")}>
          <ListItemIcon>
            <PersonIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Mi Cuenta</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => navigate("/configuracion")}>
          <ListItemIcon>
            <SettingsIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Configuración</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => { toggleDarkMode(); handleUserMenuClose(); }}>
          <ListItemIcon>
            {darkMode ? <LightModeIcon fontSize="small" /> : <DarkModeIcon fontSize="small" />}
          </ListItemIcon>
          <ListItemText>{darkMode ? "Modo claro" : "Modo oscuro"}</ListItemText>
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <LogoutIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Cerrar Sesión</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

export default UserAvatar;
